import React from 'react';
import { IconButton } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import { useCarouselContext } from '../../context/CarouselContext';

const PlayButton: React.FC = () => {
  const {
    isPlaying,
    uniqueImageTypes,
    selectedType,
    filteredImages,
    handleTogglePlay,
  } = useCarouselContext();

  const isFilteredPano = ["img_bgr_pano", "img_pano"].includes(filteredImages[0]?.imageType || '');
  const isSelectedPano = ["img_bgr_pano", "img_pano"].includes(selectedType || '');

  const showPlayButton = ((uniqueImageTypes.length === 1 && !isFilteredPano) ||
    (uniqueImageTypes.length > 1 && !isSelectedPano));

  if (!showPlayButton) return <></>;

  return (
    <IconButton
      data-cy="carousel-play-btn"
      data-tour="carousel-play-button"
      onClick={(e) => {
        e.stopPropagation();
        handleTogglePlay();
      }}
      size="small"
      style={{
        zIndex: 10,
        backgroundColor: "var(--ums-accent-red)",
        color: "#fff",
        fontWeight: "bold",
        borderRadius: 3
      }}
    >
      {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
    </IconButton>
  );
};

export default PlayButton;
